import React, { useState, useEffect } from "react";
import { LookupInput, type LookupInputOption, type LookupInputState } from "@/components/ui/LookupInput";
import { listService } from "@/services/listService";

interface IncidentTypeInputProps {
  value: string | null;
  state?: LookupInputState;
  label?: string;
  error?: string;
  placeholder?: string;
  info?: string;
  onChange?: (incidentTypeId: string | null) => void;
}

export function IncidentTypeInput({
  value,
  state = "editing",
  label = "Incident Type",
  error,
  placeholder = "Select incident type…",
  info,
  onChange,
}: IncidentTypeInputProps) {
  const [options, setOptions] = useState<LookupInputOption[]>([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let cancelled = false;
    const load = async () => {
      try {
        setLoading(true);
        const incidentTypes = await listService.getIncidentTypes();
        if (cancelled) return;
        setOptions(
          incidentTypes.map((t) => ({
            id: t.id,
            name: t.name,
            subtitle: t.description || undefined,
            icon: "alert-circle" as const,
          })),
        );
      } catch (err) {
        console.error("Failed to load incident types:", err);
      } finally {
        if (!cancelled) setLoading(false);
      }
    };
    load();
    return () => {
      cancelled = true;
    };
  }, []);

  const resolvedState: LookupInputState = loading ? "loading" : state;

  return (
    <LookupInput
      label={label}
      value={value}
      options={options}
      state={resolvedState}
      icon="alert-circle"
      error={error}
      placeholder={placeholder}
      info={info}
      onChange={onChange}
    />
  );
}
